import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  FormLabel,
} from '@mui/material'
import FormControl from '@mui/material/FormControl'
import { array } from 'yup'

import i18n from 'i18n'
import { useAppDispatch, useAppSelector } from 'redux/Hook'
import { setAnswer } from 'redux/slices/SignupFormAnswers'
import { getErrorHelperText } from 'lib/participantProfile/Helper'

type QuestionOptionType = {
  name: string
  id: number
}

export const validateCheckboxQuestion = async (
  answer: { id: string[] },
  question: QuestionsItems,
): Promise<string[]> => {
  let schema = array().nullable()

  if (question.required) {
    schema = schema
      .required()
      .min(1, i18n.t('errors.blank', { question: question.question }))
  }
  try {
    await schema.validate(answer?.id)
    return []
  } catch (err: any) {
    return err.errors
  }
}

const CheckboxQuestion = (props: CheckboxQuestionProps) => {
  const { required, question, id, options, inLineOptions, readOnlyMode } = props

  const { errors, answers } = useAppSelector((state) => state.signupAnswers)
  const error = errors[id] || []
  const answer: string[] = answers[id]?.id || []
  const dispatch = useAppDispatch()

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (readOnlyMode) return

    if (e.target.checked) {
      dispatch(
        setAnswer({
          questionId: id,
          answer: { id: [...answer, e.target.value] },
        }),
      )
    } else {
      dispatch(
        setAnswer({
          questionId: id,
          answer: {
            id: answer.filter((option) => option !== e.target.value),
          },
        }),
      )
    }
  }
  return (
    <FormControl required={required} error={error.length > 0}>
      <FormLabel> {question} </FormLabel>
      <FormGroup row={inLineOptions}>
        {options.map((option: QuestionOptionType) => {
          return (
            <FormControlLabel
              key={option.id}
              control={
                <Checkbox
                  onChange={handleChange}
                  checked={answer.indexOf(option.id.toString()) !== -1}
                />
              }
              label={option.name}
              value={option.id}
            />
          )
        })}
      </FormGroup>
      <FormHelperText sx={{ ml: 0 }}>
        {getErrorHelperText(error, question)}
      </FormHelperText>
    </FormControl>
  )
}

export default CheckboxQuestion
